import { render } from "./Pre.vue?vue&type=template&id=9b63dda4&ts=true"
import script from "./Pre.vue?vue&type=script&lang=ts"
export * from "./Pre.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__